<div class="mat-expansion-panel !bg-neutral-100">
    @if (applicationId) {
        <h3 class="application-section-header">
            Application ID: {{ applicationId }}
        </h3>
    }
    @if (applicationPurpose) {
        <h3 class="application-section-header">
            Purpose: {{ getPurposeText() }}
        </h3>
    }
    @if (orderId) {
        <h3 class="application-section-header">Order ID: {{ orderId }}</h3>
    }
</div>
